import { Description, List, Person, Settings } from '@material-ui/icons';

import { path as PageApplicationQuestionableListPath } from 'pages/PageApplicationQuestionableList';
import { path as PageAppNoteListPath } from 'pages/PageAppNoteList';
import { path as PageAppRoomTypeListPath } from 'pages/PageAppRoomTypeList';
import { path as PageAppSettingsPath } from 'pages/PageAppSettings';
import { path as PageCalendarPath } from 'pages/PageCalendar';
import { path as PageCapexCriticalLevelListPath } from 'pages/PageCapexCriticalLevelList';
import { path as PageCapexProgressListPath } from 'pages/PageCapexProgressList';
import { path as PageChecklistAfterGroupListPath } from 'pages/PageChecklistAfterGroupList';
import { path as PageClientCardPath } from 'pages/PageClientCard';
import { path as PageSelfManagedTeamListPath } from 'pages/PageSelfManagedTeamList';
import { path as PageChecklistAfterSeasonListPath } from 'pages/PageChecklistAfterSeasonList';
import { path as PageChecklistApplicationListPath } from 'pages/PageChecklistApplicationList';
import { path as PageConstructiveListPath } from 'pages/PageConstructiveList';
import { path as PageConsultationsPath } from 'pages/PageConsultations';
import { path as PagePersonnelTrainingListPath } from 'pages/PagePersonnelTrainingList';
import { path as PageContragentBadAddPath } from 'pages/PageContragentBadAdd';
import { path as PageContragentBadDeletePath } from 'pages/PageContragentBadDelete';
import { path as PageCostCategoryListPath } from 'pages/PageCostCategoryList';
import { path as PageCriteriaRatingListPath } from 'pages/PageCriteriaRatingList';
import { path as PageCriteriaRatingUGOListPath } from 'pages/PageCriteriaRatingUGOList';
import { path as PageDefectActBrandListPath } from 'pages/PageDefectActBrandList';
import { path as PageDefectActDivisionListPath } from 'pages/PageDefectActDivisionList';
import { path as PageDefectActReasonsPath } from 'pages/PageDefectActReasons';
import { path as PageDefectActWorkGuaranteeListPath } from 'pages/PageDefectActWorkGuaranteeList';
import { path as PageDefectTypeListPath } from 'pages/PageDefectTypeList';
import { path as PageDelayReasonClientListPath } from 'pages/PageDelayReasonClientList';
import { path as PageDelayReasonsPath } from 'pages/PageDelayReasons';
import { path as PageDivisionListPath } from 'pages/PageDivisionList';
import { path as PageDoneApplicationsPath } from 'pages/PageDoneApplications';
import { path as PageEquipmentPprListPath } from 'pages/PageEquipmentPprList';
import { path as PageEquipmentTypePprListPath } from 'pages/PageEquipmentTypePprList';
import { path as PageEventTypeListPath } from 'pages/PageEventTypeList';
import { path as PageExtraRolesListPath } from 'pages/PageExtraRolesList';
import { path as PageGprPath } from 'pages/PageGpr';
import { path as PageJournalEquipmentPprListPath } from 'pages/PageJournalEquipmentPprList';
import { path as PageLogsPath } from 'pages/PageLogs';
import { path as PageMailingListPath } from 'pages/PageMailingList';
import { path as PageManagementUGOListPath } from 'pages/PageManagementUGOList';
import { path as PageOrkChecklistPath } from 'pages/PageOrkChecklist';
import { path as PagePositionListPath } from 'pages/PagePositionList';
import { path as PageProjectEquipmentPprListPath } from 'pages/PageProjectEquipmentPprList';
import { path as PageReasonUsoListPath } from 'pages/PageReasonUsoList';
import { path as PageReopenReasonListPath } from 'pages/PageReopenReasonList';
import { path as PageRepairTypesPath } from 'pages/PageRepairTypes';
import { path as PageServiceTypeListPath } from 'pages/PageServiceTypeList';
import { path as PageSourceListPath } from 'pages/PageSourceList';
import { path as PageSubConstructiveListPath } from 'pages/PageSubConstructiveList';
import { path as PageSubZoneListPath } from 'pages/PageSubZoneList';
import { path as PageTariffIncreasePlanListPath } from 'pages/PageTariffIncreasePlanList';
import { path as PageTechMapWorkTypeListPath } from 'pages/PageTechMapWorkTypeList';
import { path as PageTempEmployeeListPath } from 'pages/PageTempEmployeeList';
import { path as PageTypeTechnicalRoomPprListPath } from 'pages/PageTypeTechnicalRoomPprList';
import { path as PageWarrantyCardPath } from 'pages/PageWarrantyCard';
import { path as PageWorkListPprPath } from 'pages/PageWorkListPpr';
import { path as PageWorkTypeListPath } from 'pages/PageWorkTypeList';
import { path as PageYardListPath } from 'pages/PageYardList';
import { path as PageObjectTypeListPath } from 'pages/PageObjectTypeList';
import { path as PageZoneListPath } from 'pages/PageZoneList';
import { path as PageAmortizationListPath } from 'pages/CalculatorTariff/PageAmortizationList';
import { path as PageCheckListSchemaListPath } from 'pages/CalculatorTariff/PageCheckListSchemaList';
import { path as PageDepartmentListPath } from 'pages/CalculatorTariff/PageDepartmentList';
import { path as PageGateMarkListPath } from 'pages/CalculatorTariff/PageGateMarkList';
import { path as PageFixedItemListPath } from 'pages/CalculatorTariff/PageFixedItemList';
import { path as PageMaterialsOutsourcingListPath } from 'pages/CalculatorTariff/PageMaterialsOutsourcingList';
import { path as PagePriceListServicesListPath } from 'pages/CalculatorTariff/PagePriceListServicesList';
import { path as PagePersonalWorkloadListPath } from 'pages/CalculatorTariff/PagePersonalWorkloadList';
import { path as PageModelListPath } from 'pages/CalculatorTariff/PageModelList';
import { path as PagePersonalSalaryListPath } from 'pages/CalculatorTariff/PagePersonalSalaryList';
import { path as PageChronaVisitListPath } from 'pages/Chrona/PageChronaVisitList';
import { path as PageChronaVisitDashboardPath } from 'pages/Chrona/PageChronaVisitDashboard';
import { path as PageChronaObjectListPath } from 'pages/Chrona/PageChronaObjectList';
import { path as PageChronaMatrixPath } from 'pages/Chrona/PageChronaMatrix';
import { path as PageChronaAuditLogPath } from 'pages/Chrona/PageChronaAuditLog';
import { path as PageChronaSettingsPath } from 'pages/Chrona/PageChronaSettings';
import { path as PageChronaMapPath } from 'pages/Chrona/PageChronaMap';
import { path as PageChronaAccessPath } from 'pages/Chrona/PageChronaAccess';
import { SideBarNavMenuItem } from './types';

export const SIDEBAR_MENU: SideBarNavMenuItem[] = [
  {
    name: 'Tracker (учёт посещений)',
    // Меню гейтится операциями CHRONA_*_VIEW — они заведены ровно под показ пунктов, а
    // права на данные (CHRONA_VIEW / CHRONA_MANAGER_FIX / CHRONA_ADMIN) проверяет сервер.
    // Одно и то же правило в вебе и в мобилке, иначе одна роль показывала бы пункт в
    // одном клиенте и прятала в другом.
    //
    // Только явно выданные роли: ADMIN убран. Операция ADMIN приходит с должностью
    // администратора системы и открывала бы реестр визитов — чужие перемещения,
    // координаты и фото — всем её носителям, без выдачи роли. Бэк с этим согласован:
    // ручки модуля проверяются checkOperation, без обхода по должности.
    // Носителю CHRONA_ADMIN отдельные галочки меню не нужны — CHRONA_ADMIN_ROLE входит
    // в каждую меню-операцию на бэке.
    operations: [
      'CHRONA_VISITS_MENU',
      'CHRONA_REVIEW_MENU',
      'CHRONA_ADMIN_MENU',
      'CHRONA_OBJECT_EDIT',
      'CHRONA_OBJECT_VIEW',
    ],
    Icon: Settings,
    children: [
      {
        name: 'Визиты',
        operations: ['CHRONA_VISITS_MENU', 'CHRONA_REVIEW_MENU', 'CHRONA_ADMIN_MENU'],
        path: PageChronaVisitDashboardPath,
      },
      {
        // Плоский список отметок с подтверждением, отклонением и выгрузкой (SERVICE-5428).
        name: 'Реестр отметок',
        operations: ['CHRONA_VISITS_MENU', 'CHRONA_REVIEW_MENU', 'CHRONA_ADMIN_MENU'],
        path: PageChronaVisitListPath,
      },
      {
        // Менеджеру объекта раздел нужен: он заводит геозоны своих ЖК. Гейт по праву на данные,
        // а не по меню-роли — иначе пункт видно, а за ним отказ доступа.
        name: 'Объекты геоконтроля',
        operations: ['CHRONA_ADMIN_MENU', 'CHRONA_OBJECT_EDIT', 'CHRONA_OBJECT_VIEW'],
        path: PageChronaObjectListPath,
      },
      {
        // Карта только показывает: те же операции, что у визитов, а не админские. Руководителю
        // она нужнее таблицы — на ней сразу виден объект, где геоконтроль забыли включить.
        name: 'Карта объектов',
        operations: ['CHRONA_VISITS_MENU', 'CHRONA_ADMIN_MENU'],
        path: PageChronaMapPath,
      },
      {
        name: 'Назначения сотрудников',
        operations: ['CHRONA_ADMIN_MENU', 'CHRONA_OBJECT_EDIT', 'CHRONA_OBJECT_VIEW'],
        path: PageChronaMatrixPath,
      },
      {
        // Журнал без объектного скоупа: меню-роль визитов его не открывает, только право на журнал геоконтроля.
        name: 'Журнал изменений',
        operations: ['CHRONA_AUDIT_VIEW'],
        path: PageChronaAuditLogPath,
      },
      {
        name: 'Настройки модуля',
        operations: ['CHRONA_ADMIN_MENU'],
        path: PageChronaSettingsPath,
      },
      {
        // Выдачи ведёт только админ модуля: меню-роль админских разделов без CHRONA_ADMIN получила бы отказ.
        name: 'Доступы',
        operations: ['CHRONA_ADMIN'],
        path: PageChronaAccessPath,
      },
    ],
  },

  {
    name: 'Акты приема помещений',
    Icon: Description,
    operations: ['ORK_ACT_VIEW'],
    path: PageOrkChecklistPath,
  },

  {
    name: 'Технические справочники',
    operations: [],
    Icon: List,
    searchable: true,
    children: [
      {
        name: 'Журнал учета оборудования',
        operations: ['JOURNAL_EQUIPMENT_LIST_VIEW'],
        path: PageJournalEquipmentPprListPath,
      },
      {
        name: 'Тип услуг',
        operations: ['ADMIN'],
        path: PageServiceTypeListPath,
      },
      {
        name: 'Критерии оценки',
        operations: ['ADMIN'],
        path: PageCriteriaRatingListPath,
      },
      {
        name: 'Статьи затрат',
        operations: ['ADMIN'],
        path: PageCostCategoryListPath,
      },
      {
        name: 'Добавление в реестр НП',
        operations: ['CONTRAGENT_BAD_EDIT'],
        path: PageContragentBadAddPath,
      },
      {
        name: 'Снятие с реестра НП',
        operations: ['CONTRAGENT_BAD_EDIT'],
        path: PageContragentBadDeletePath,
      },
      {
        name: 'Виды работ по гарантии',
        operations: ['MANAGER_DEFECT_ACT_WORK_GUARANTEE'],

        path: PageDefectActWorkGuaranteeListPath,
      },
      {
        name: 'Бренды',
        operations: ['MANAGER_DEFECT_ACT_BRAND'],
        path: PageDefectActBrandListPath,
      },
      {
        name: 'Группы',
        operations: ['MANAGER_CHECK_LIST_AFTER_INDICATOR'],
        path: PageChecklistAfterGroupListPath,
      },
      {
        name: 'Дивизионы',
        operations: ['MANAGER_DIVISION'],
        path: PageDivisionListPath,
      },
      {
        name: 'Дивизионы для дефектного акта',
        operations: ['DEFECT_ACT_DIVISION_EDITOR'],
        path: PageDefectActDivisionListPath,
      },
      {
        name: 'Источники обращений',
        operations: ['ADMIN'],
        path: PageSourceListPath,
      },
      {
        name: 'Типы замечаний',
        operations: ['DEFECT_TYPE_EDIT'],
        path: PageDefectTypeListPath,
      },
      {
        name: 'Типы событий',
        path: PageEventTypeListPath,
        operations: ['EVENT_EDITOR_OPERATION'],
      },
      {
        name: 'Типы помещений',
        operations: ['ORK_CHECKLIST_EDIT'],
        path: PageAppRoomTypeListPath,
      },
      {
        name: 'Примечания ЖК для АПП',
        operations: ['ORK_CHECKLIST_EDIT'],
        path: PageAppNoteListPath,
      },
      {
        name: 'Причины для статуса “В ожидании”',
        path: PageDelayReasonClientListPath,
        operations: ['ADMIN'],
      },
      {
        name: 'Причины отклонения заявок УСО',
        operations: ['REASON_USO_MANAGER'],
        path: PageReasonUsoListPath,
      },
      {
        name: 'Причины переоткрытий',
        path: PageReopenReasonListPath,
        operations: ['REOPEN_REASON_OPERATION'],
      },
      {
        name: 'Причины по спорным заявкам',
        path: PageApplicationQuestionableListPath,
        operations: ['ADMIN'],
      },
      {
        name: 'Причины дефектов',
        path: PageDefectActReasonsPath,
        operations: ['DEFECT_ACT_REASON_OPERATION'],
      },
      {
        name: 'Самоуправляемая команда',
        operations: ['MANAGER_SELF_MANAGED_TEAM'],
        path: PageSelfManagedTeamListPath,
      },
      {
        name: 'Дворы',
        operations: ['ADMIN'],
        path: PageYardListPath,
      },
      {
        name: 'Типы объектов',
        operations: ['MANAGER_REAL_ESTATE_OBJECT_TYPE'],
        path: PageObjectTypeListPath,
      },
      {
        name: 'Сезоны',
        operations: ['MANAGER_CHECK_LIST_AFTER_INDICATOR'],
        path: PageChecklistAfterSeasonListPath,
      },
      {
        name: 'Локации',
        operations: ['CLASSIFIER_DICTIONARY_EDIT'],
        path: PageZoneListPath,
      },
      {
        name: 'Проблемы',
        operations: ['CLASSIFIER_DICTIONARY_EDIT'],
        path: PageConstructiveListPath,
      },
      {
        name: 'Элементы',
        operations: ['CLASSIFIER_DICTIONARY_EDIT'],
        path: PageSubConstructiveListPath,
      },
      {
        name: 'Системы',
        operations: ['CLASSIFIER_DICTIONARY_EDIT'],
        path: PageSubZoneListPath,
      },
      {
        name: 'Чек - листы в заявках',
        operations: ['APPLICATION_CHECK_LIST'],
        path: PageChecklistApplicationListPath,
      },
      {
        name: 'Виды ремонта',
        path: PageRepairTypesPath,
        operations: ['REPAIR_TYPE_OPERATION'],
      },
      {
        name: 'Виды работ',
        operations: ['WORK_TYPE_MANAGER'],
        path: PageWorkTypeListPath,
      },
      {
        name: 'Консультации',
        path: PageConsultationsPath,
        operations: ['MANAGE_CONSULTATION_TYPE'],
      },
      {
        name: 'Выполнения',
        path: PageDoneApplicationsPath,
        operations: ['MANAGE_DONE_RESPONSE'],
      },
      {
        name: 'Типы продлений',
        path: PageDelayReasonsPath,
        operations: ['MANAGE_DELAY_REASON'],
      },
      {
        name: 'Гарантийный талон',
        operations: ['MANAGE_BIG_APP_WARRANTY_CARD'],
        path: PageWarrantyCardPath,
      },
      {
        name: 'Виды и этапы работ',
        operations: ['TECH_MAP_MANAGER'],
        path: PageTechMapWorkTypeListPath,
      },
      {
        name: 'Ход исполнения Capex',
        operations: ['PROGRESS_CAPEX_MANAGER'],
        path: PageCapexProgressListPath,
      },
      {
        name: 'Уровни критичности Capex',
        operations: ['MANAGEMENT_UGO'],
        path: PageCapexCriticalLevelListPath,
      },
      {
        name: 'Управления УГО',
        operations: ['MANAGEMENT_UGO'],
        path: PageManagementUGOListPath,
      },
      {
        name: 'Рейтинг УГО',
        operations: ['CRITERIA_RATING_UGO_EDIT'],
        path: PageCriteriaRatingUGOListPath,
      },
      {
        name: 'Оборудование',
        operations: ['MANAGER_DICTIONARY_EQUIPMENT_TYPE'],
        path: PageEquipmentPprListPath,
      },
      {
        name: 'Обучения персонала',
        operations: ['PERSONNEL_TRAINING_DICTIONARY_EDIT'],
        path: PagePersonnelTrainingListPath,
      },

      {
        name: 'График плановых работ',
        operations: ['TECH_MAP_MANAGER', 'TECH_MAP_MANAGER_ENGINEER'],
        path: PageGprPath,
      },

      {
        name: 'План повышения тарифа',
        operations: ['TECH_MAP_MANAGER'],
        path: PageTariffIncreasePlanListPath,
      },

      {
        groupName: 'Калькулятор тарифа',
        operations: ['CALCULATOR_TARIFF_DICT_MANAGER'],
      },

      {
        name: 'Модели расчёта тарифа',
        operations: ['CALCULATOR_TARIFF_DICT_MANAGER'],
        path: PageModelListPath,
      },

      {
        name: 'Модель чек-листов',
        operations: ['CALCULATOR_TARIFF_DICT_MANAGER'],
        path: PageCheckListSchemaListPath,
      },

      {
        name: 'Зарплата сотрудников',
        operations: ['CALCULATOR_TARIFF_DICT_MANAGER'],
        path: PagePersonalSalaryListPath,
      },

      {
        name: 'Отделы',
        operations: ['CALCULATOR_TARIFF_DICT_MANAGER'],
        path: PageDepartmentListPath,
      },

      {
        name: 'Марки ворот',
        operations: ['CALCULATOR_TARIFF_DICT_MANAGER'],
        path: PageGateMarkListPath,
      },

      {
        name: 'Материалы для аутсорсинга',
        operations: ['CALCULATOR_TARIFF_DICT_MANAGER'],
        path: PageMaterialsOutsourcingListPath,
      },

      {
        name: 'Амортизация',
        operations: ['CALCULATOR_TARIFF_DICT_MANAGER'],
        path: PageAmortizationListPath,
      },

      {
        name: 'Прайс по услугам',
        operations: ['CALCULATOR_TARIFF_DICT_MANAGER'],
        path: PagePriceListServicesListPath,
      },

      {
        name: 'Нагрузка на персонал',
        operations: ['CALCULATOR_TARIFF_DICT_MANAGER'],
        path: PagePersonalWorkloadListPath,
      },

      {
        name: 'Закреплённые подстатьи',
        operations: ['CALCULATOR_TARIFF_DICT_MANAGER'],
        path: PageFixedItemListPath,
      },

      {
        groupName: 'ППР',
        operations: ['MANAGER_TECH_ROOM', 'MANAGER_DICTIONARY_EQUIPMENT_TYPE', 'DICTIONARY_WORK_MANAGER'],
      },

      {
        name: 'Типы помещений ППР',
        operations: ['MANAGER_TECH_ROOM'],
        path: PageTypeTechnicalRoomPprListPath,
      },
      {
        name: 'Типы оборудования ППР',
        operations: ['MANAGER_DICTIONARY_EQUIPMENT_TYPE'],
        path: PageEquipmentTypePprListPath,
      },
      {
        name: 'Работы ППР',
        operations: ['DICTIONARY_WORK_MANAGER'],
        path: PageWorkListPprPath,
      },
      {
        name: 'Оборудование в разрезе проектов',
        operations: ['MANAGER_DICTIONARY_EQUIPMENT'],
        path: PageProjectEquipmentPprListPath,
      },
    ],
  },

  {
    name: 'Параметры администратора',
    operations: [],
    Icon: Settings,
    children: [
      {
        name: 'Должности',
        operations: ['POSITION_ADMIN_OPERATION'],
        path: PagePositionListPath,
      },
      {
        name: 'Доп. роли',
        path: PageExtraRolesListPath,
        operations: ['EXTRA_ROLE_OPERATION'],
      },
      {
        name: 'Логирование действий',
        path: PageLogsPath,
        operations: ['VIEW_AUDIT_LOG'],
      },
      {
        name: 'Адресаты рассылки',
        path: PageMailingListPath,
        operations: ['MAIL_EDITOR_OPERATION'],
      },
      {
        name: 'Календарь',
        path: PageCalendarPath,
        operations: ['VIEW_CALENDAR'],
      },
      {
        name: 'Создание сотрудника',
        path: PageTempEmployeeListPath,
        operations: ['USER_KEYCLOAK_ADMIN'],
      },
      {
        name: 'Настройки приложения',
        path: PageAppSettingsPath,
        operations: ['APP_SETTINGS_MANAGER'],
      },
    ],
  },

  {
    name: 'Карточка клиента',
    Icon: Person,
    operations: ['CLIENT_CARD_INFO'],
    path: PageClientCardPath,
  },
];
